var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{ selected: _vm.selected },attrs:{"disabled":_vm.disabled},on:{"click":_vm.cardSelect}},[_c('div',[_c('GL-Icon',{staticClass:"icon",attrs:{"path":_vm.iconPath,"size":_vm.iconSize}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }